import { useEffect, useState, useLayoutEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAtom } from 'jotai'
import {
    UserSession,
    AdminUser
  } from '../../utils'
import { Client, Account } from "appwrite";
import DashboardMenu from '../../components/DashboardMenu.jsx'
import Skeleton from '@mui/material/Skeleton';
import { Query } from 'appwrite'
import ThemeOption from '../../components/ThemeOption.jsx'
import { logout } from '../../utils.js'
import { useUser } from '../../GlobalContext.jsx'
import LogoLoader from '../../components/LogoLoader';

import { PageContainer } from '@toolpad/core/PageContainer';
import Grid from '@mui/material/Grid2';
import { OutlinedActionCard } from '../../components/OutlinedCard.jsx';
import DocumentScannerOutlinedIcon from '@mui/icons-material/DocumentScannerOutlined';
import LineWeightOutlinedIcon from '@mui/icons-material/LineWeightOutlined';
import ManageSearchOutlinedIcon from '@mui/icons-material/ManageSearchOutlined';
import RuleOutlinedIcon from '@mui/icons-material/RuleOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';


const client = new Client()
    .setEndpoint(process.env.REACT_APP_ENDPOINT)
    .setProject(process.env.REACT_APP_PROJECT_ID);

const account = new Account(client);


export default function AddWidgets() {
    const navigate = useNavigate()
    const [userSession, setUserSession] = useAtom(UserSession);

    const [isLoading, setIsLoading] = useState(true);
    const [showLoadingScreen, setShowLoadingScreen] = useState(false);
    
    // Set authenticated session on initial page load
    useEffect(() => {
        const checkSession = async () => {
            try {
                const user = await account.get()
                return user
            } catch (error) {
                navigate('/')
            }
        }
        setUserSession(checkSession())
    }, []);

    // Display loading screen while the page loads
    useLayoutEffect(() => {
        const timeoutId = setTimeout(() => {
            setShowLoadingScreen(true);
        }, 50);
    
        return () => clearTimeout(timeoutId);
    }, []);
    
    useLayoutEffect(() => {
        const timeoutId = setTimeout(() => {
            setIsLoading(false);
        }, 0);
    
        return () => clearTimeout(timeoutId);
    }, []);
    
    if (isLoading && showLoadingScreen) return <LogoLoader />;

    return (<>
        {userSession && <DashboardMenu path="" user={userSession} page={userSession && (<div className="page-content">
            <h1>Widget Library</h1>
            <br/>
            <Grid container spacing={1}>
                <Grid size={6}>
                    <OutlinedActionCard icon={<ManageSearchOutlinedIcon />} name="Bid Scanner" price="" desc="Scans a takeoff PDF and highlights the provided keywords."/>
                </Grid>
                <Grid size={6}>
                    <OutlinedActionCard icon={<DocumentScannerOutlinedIcon />} name="Schedule Extractor" price="" desc="Scans a takeoff PDF for schedules/legends and exports the data to a spreadsheet."/>
                </Grid>
                <Grid size={6}>
                    <OutlinedActionCard icon={<AssessmentOutlinedIcon />} name="Wall Height Calculator" price="" desc="Calculates wall heights from a PDF and exports the data to a spreadsheet."/>
                </Grid>
                <Grid size={6}>
                    <OutlinedActionCard icon={<RuleOutlinedIcon />} name="Irrigation Auditor" price="" desc="Audit irrigation zones step-by-step and save data directly to your Google account."/>
                </Grid>
            </Grid>
        </div>)} />}
    </>)
}